// 约课状态，0 不可约、1 未约课、2 已约课未开课、3 已约课已开课
export const BOOK_STATUS = {
  UNBOOK: 0,
  NOBOOK: 1,
  BOOKED_NO_START: 2,
  BOOKED_START: 3,
};

export const UPDATE_COURSE_TIME_IDENTITY = 'update_course_time_identity';
export const BOOK_OPERATION = {
  PRE_VALIDATE: 0,
  BOOK: 1,
};
export const BOOK_FAIL_TYPE = {
  NO_FAIL: 0,
  TIME_CONFLICT: 1,
  COURSE_BEGUN: 2,
};
